import React from "react"
function Services (){
    return (
        <>
        <section className="services" id="services">
    <h2 className="heading">Services</h2>
    <div className="services-container">
        <div className="services-box">
            <div className="services-info">
                <h4>Web Developer</h4>
                <p>I possess the programming and design skills necessary to build interactive websites and applications. I utilize my proficiency in HTML, CSS, and JavaScript to design user interfaces, connect websites to databases, test and maintain them, develop new features, and ensure their security</p>
            </div>
        </div>

        <div className="services-box">
            <div className="services-info">
                <h4>UI/UX Developer</h4>
                <p>skills and expertise to create seamless and effective user experiences. I have a strong background in design and programming, and I am proficient in using tools like Adobe XD, Figma, and Photoshop to craft user-friendly and visually appealing interfaces.
                </p>
            </div>
        </div>


        <div className="services-box">
            <div className="services-info">
                <h4>Computer Trainer</h4>
                <p>I have experience in general training and teaching to all ages in a general area such as computer basic and graphic design and web development
                    learning training  more than 5 years of teaching experience.</p>
            </div>
        </div>




        <div className="services-box">
            <div className="services-info">
                <h4>Graphic Designer</h4>
                <p>Creative graphic designer with strong technical & programming skills for impactful projects. Skilled in Adobe Photoshop, Illustrator & InDesign for marketing materials (logos, graphics, ads) & digital design UI, mobile apps, websites</p>
            </div>
        </div>


        
        <div className="services-box">
            <div className="services-info">
                <h4>Video Editing </h4>
                <p>Skilled video editor with creative vision. Utilizes Adobe Premiere Pro & Filmora to craft engaging videos for ads, marketing (brand awareness, product promotion), </p>
            </div>
        </div>


        <div className="services-box">
            <div className="services-info">
                <h4>videographer</h4>
                <p>Skilled & experienced videographer with creative vision. Shoots captivating video for documentaries, short films, commercials, & marketing (brand awareness, product promotion)</p>
            </div>
        </div>



    </div>
</section>

        </>
    )
}
export default Services